import { render, staticRenderFns } from "./DPadFlex.vue?vue&type=template&id=ed96fc8e&scoped=true"
import script from "./DPadFlex.vue?vue&type=script&lang=js"
export * from "./DPadFlex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed96fc8e",
  null
  
)

export default component.exports